import type { Engineer, Instellingen } from './types';

export interface Coord { lat?: number | null; lon?: number | null }
export interface Reis { km: number; min: number }

/** Geschatte wegafstand (km) tussen twee coördinaten (SPEC §3.3). */
export function kmSchatting(a: Coord, b: Coord, cfg: Pick<Instellingen, 'reisFactor'>): number | null {
  if (a.lat == null || a.lon == null || b.lat == null || b.lon == null) return null;
  const x = Math.abs(a.lat - b.lat) * 111.2;
  const y = Math.abs(a.lon - b.lon) * 68.9;
  return (Math.max(x, y) + 0.41 * Math.min(x, y)) * (cfg.reisFactor || 1.3);
}

export function minutenVoorKm(km: number, cfg: Pick<Instellingen, 'reisSnelheid' | 'reisOpslag'>): number {
  if (km < 1) return 0;
  return Math.round((km / Math.max(10, cfg.reisSnelheid || 70)) * 60 + (cfg.reisOpslag ?? 10));
}

export function vertrekpunt(e: Engineer, cfg: Instellingen): Coord {
  return e.startlocatie === 'KANTOOR' ? { lat: cfg.kantoorLat, lon: cfg.kantoorLon } : { lat: e.lat, lon: e.lon };
}

/** Enkele reis van engineer naar bestemming, of null als een coördinaat ontbreekt. */
export function reis(e: Engineer, bestemming: Coord, cfg: Instellingen): Reis | null {
  const k = kmSchatting(vertrekpunt(e, cfg), bestemming, cfg);
  if (k == null) return null;
  return { km: Math.round(k), min: minutenVoorKm(k, cfg) };
}

/** Telbare reisuren per dag: heen + terug minus eigen reistijd per rit, afgerond op een kwartier omhoog. */
export function reisUren(reisMin: number | null | undefined, cfg: Pick<Instellingen, 'eigenReistijd'>): number {
  if (!reisMin) return 0;
  return Math.ceil((2 * Math.max(0, reisMin - (cfg.eigenReistijd || 0))) / 15) / 4;
}

export const REGIO_KM = 25;
export const REGIO_BONUS = 10;
